<div class="confirmation-dialog">
    <!-- Dialog Header -->
    <div mat-dialog-title class="dialog-header d-flex align-items-center justify-content-between m-1 p-1">
        <div class="title-content d-flex align-items-center gap-2">
            <mat-icon [color]="getIconColor()" class="dialog-icon fs-4">
                {{ getDialogIcon() }}
            </mat-icon>
            <h2 class="m-0 fw-medium fs-5">{{ data.title }}</h2>
        </div>
        <button matIconButton
                [mat-dialog-close]="{ confirmed: false }"
                class="close-button"
                aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Dialog Content -->
    <div mat-dialog-content class="dialog-content">
        <p class="dialog-message m-0 lh-base">{{ data.message }}</p>
    </div>

    <!-- Dialog Actions -->
    <div mat-dialog-actions class="dialog-actions d-flex justify-content-end gap-2 m-0 p-0">
        @if(data.cancelLabel) {
            <button matButton="outlined"
                    [mat-dialog-close]="{ confirmed: false }"
                    class="cancel-button">
                {{ data.cancelLabel }}
            </button>
        }
    
        <button matButton="filled"
            [color]="getConfirmButtonColor()"
            [mat-dialog-close]="{ confirmed: true }"
            class="confirm-button d-flex align-items-center gap-1"
            cdkTrapFocus>
            @if(getConfirmIcon()){
                <mat-icon>{{ getConfirmIcon() }}</mat-icon>
            }
            {{ data.confirmLabel || 'OK' }}
        </button>
    </div>
</div>